import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import './../styles/layout.css';

const Layout = () => {
  return (
    <div className="app-container">
      <Navbar />
      <div className="main-content">
        <Outlet />
      </div>
      <footer className="footer">
        <p>© {new Date().getFullYear()} ARN. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Layout;
